import type { TableWrapperProps } from '../types';

import { PAGE_TITLE_CLASS_NAME } from '@/components/ui/card';

import { cn } from '@/lib/utils';

export const TableWrapper = (props: TableWrapperProps) => {
  const { title, recordsTotal = 0, headerActions, children, className } = props;

  const displayTitle =
    typeof title === 'function' ? title(recordsTotal) : title;
  const countSuffix = ` (${recordsTotal})`;
  const hasCount =
    typeof title === 'function' && !!displayTitle?.endsWith(countSuffix);
  const titleText = hasCount
    ? displayTitle?.slice(0, -countSuffix.length)
    : displayTitle;

  return (
    <section className={cn('flex flex-col gap-3', className)}>
      {(displayTitle || headerActions) && (
        <div className="flex flex-wrap items-center justify-between gap-3">
          {displayTitle && (
            <h1 className={PAGE_TITLE_CLASS_NAME}>
              {titleText}
              {hasCount && (
                <span className="text-muted-foreground ml-2 text-xl font-normal tabular-nums">
                  ({recordsTotal})
                </span>
              )}
            </h1>
          )}
          {headerActions && (
            <div className="flex flex-wrap items-center gap-2">
              {headerActions}
            </div>
          )}
        </div>
      )}
      <div className="flex flex-col gap-3">{children}</div>
    </section>
  );
};
